import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// import MobileWarning from '@/components/MobileWarning/MobileWarning';
import { AdminSubscriptions } from 'components/WebsocketSubscriptions';
import Layout from './components/Layout';
import { thunkFetchAdmin, setCurrentClientID, thunkFetchAllClients } from './redux/actions';
import { isSuperAdmin as isSuper } from '@/redux/util';
import { useClientManagement } from './hooks/useClientManagement';
import RootRoutes from './routes/RootRoutes/RootRoutes';

function App({
	admins,
	adminSSOProfile,
	setCurrentClientID,
	fetchAllClients,
	clients,
	auth0Token,
	currentClientID,
	fetchAdmin,
}) {
	const fetchPermissions = initialFetch => {
		if (adminSSOProfile?.email) {
			const adminPermissions = admins[adminSSOProfile.email];
			if (!isSuper() && auth0Token && (!adminPermissions || initialFetch)) {
				fetchAdmin(adminSSOProfile.email, 'App fetchPermissions');
			}
		}
	};

	useEffect(() => {
		console.log('App mounted');
		fetchPermissions(true);
	}, []);

	useClientManagement({
		clients,
		adminSSOProfile,
		admins,
		currentClientID,
		auth0Token,
		setCurrentClientID,
		fetchPermissions,
	});

	useEffect(() => {
		if (auth0Token) {
			fetchAllClients();
		}
	}, [auth0Token]);

	return (
		// <MobileWarning>
		<Layout>
			<AdminSubscriptions>
				<RootRoutes />
			</AdminSubscriptions>
		</Layout>
		// </MobileWarning>
	);
}

const msp = ({ auth, admins, clients }) => ({
	adminSSOProfile: auth.adminSSOProfile,
	auth0Token: auth.auth0Token,
	clients: clients.clients,
	currentClientID: clients.currentClient.id,
	admins,
});

const mdp = dispatch => ({
	fetchAdmin: (email, from) => dispatch(thunkFetchAdmin(email, from)),
	setCurrentClientID: clientID => dispatch(setCurrentClientID(clientID)),
	fetchAllClients: from => dispatch(thunkFetchAllClients(from)),
});

export default connect(msp, mdp)(App);
